import React from 'react';
import SafeIcon from '../common/SafeIcon';

const TemplateLibrary = ({ templates, onTemplateClick }) => {
  if (templates.length === 0) {
    return null;
  }

  const handleDragStart = (event, template) => {
    event.dataTransfer.effectAllowed = 'copy';
    event.dataTransfer.setData('template-id', template.id);
  };

  return (
    <section className="bg-white border border-gray-200 rounded-xl p-5 mb-8 shadow-sm no-print">
      <div className="flex items-center justify-between gap-4 mb-4">
        <div>
          <h2 className="font-bold text-gray-900">Gespeicherte Vorlagen</h2>
          <p className="text-xs text-gray-500 mt-1">
            Vorlage anklicken oder per Drag & Drop in die Analyse ziehen
          </p>
        </div>
        <SafeIcon name="Move" className="text-gray-400" />
      </div>

      <div className="flex flex-wrap gap-3">
        {templates.map((template) => (
          <button
            key={template.id}
            draggable
            onDragStart={(event) => handleDragStart(event, template)}
            onClick={() => onTemplateClick(template)}
            className="flex items-center gap-2 bg-gray-50 hover:bg-red-50 border border-gray-200 hover:border-red-300 rounded-lg px-4 py-3 text-sm font-semibold text-gray-700 hover:text-red-700 transition-all cursor-grab active:cursor-grabbing"
          >
            <SafeIcon name="FileText" />
            {template.name}
          </button>
        ))}
      </div>
    </section>
  );
};

export default TemplateLibrary;